/// <reference types="@shopify/polaris-types" />
import type { AutocompleteBalanceResponse } from "@codway-dev/shared";
import styles from "./AddressValidatorPage.module.css";

type PackageItem = AutocompleteBalanceResponse["packages"][number];

export function PackCard({
  pack,
  buying,
  onBuy,
}: {
  pack: PackageItem;
  buying: string | null;
  onBuy: (id: string) => void;
}) {
  const isLoading = buying === pack.id;
  const isPopular = pack.id === "growth";
  const isDisabled = buying !== null;

  return (
    <div style={{ position: "relative", paddingTop: "10px" }}>
      {isPopular && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: "50%",
            transform: "translateX(-50%)",
            backgroundColor: "#008060",
            color: "#fff",
            fontSize: "11px",
            fontWeight: 700,
            padding: "1px 10px",
            borderRadius: "99px",
            whiteSpace: "nowrap",
            zIndex: 1,
          }}
        >
          ★ POPULAR
        </div>
      )}
      <div
        onClick={() => !isDisabled && onBuy(pack.id)}
        className={styles.packCard}
        data-popular={isPopular || undefined}
        data-disabled={isDisabled || undefined}
        style={{
          position: "relative",
          borderRadius: "8px",
          padding: "16px",
          cursor: isDisabled ? "not-allowed" : "pointer",
          opacity: isDisabled && !isLoading ? 0.6 : 1,
          backgroundColor: "#fff",
          userSelect: "none",
        }}
      >
        <div
          style={{
            fontSize: "11px",
            fontWeight: 600,
            color: "#6d7175",
            textTransform: "uppercase",
            letterSpacing: "0.05em",
            marginBottom: "8px",
          }}
        >
          {pack.name.toUpperCase()}
        </div>

        <div style={{ marginBottom: "6px" }}>
          <span style={{ fontSize: "22px", fontWeight: 700, color: "#202223" }}>
            {pack.credits.toLocaleString("es")}
          </span>
          <span
            style={{ fontSize: "13px", color: "#6d7175", marginLeft: "4px" }}
          >
            créditos
          </span>
        </div>

        <div style={{ display: "flex", alignItems: "baseline", gap: "4px" }}>
          <span style={{ fontSize: "18px", fontWeight: 700, color: "#202223" }}>
            ${pack.price_usd}
          </span>
          <span style={{ fontSize: "12px", color: "#8c9196" }}>USD</span>
        </div>

        {isLoading && (
          <div
            style={{
              position: "absolute",
              inset: 0,
              backgroundColor: "rgba(255,255,255,0.8)",
              borderRadius: "8px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <span style={{ fontSize: "12px", color: "#6d7175" }}>
              Redirigiendo…
            </span>
          </div>
        )}
      </div>
    </div>
  );
}
